/* All my Blue — motion layer (~2 KB)
   Reveal on scroll, compact header, hero photo parallax, blog card photo.
   Everything is CSS; this only toggles classes and two custom properties.
   Off when prefers-reduced-motion or the theme setting "Animations" is off
   (then <html> has no .amb-motion and the CSS shows the final state). */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('amb-motion')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.classList.remove('amb-motion');
    return;
  }

  function boot() {
    requestAnimationFrame(function () { root.classList.add('amb-ready'); });

    var els = document.querySelectorAll('[data-amb-reveal]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }

    /* On desktop Horizon scrolls .page-wrapper instead of the window */
    var header = document.querySelector('.amb-header');
    var pw = document.querySelector('.page-wrapper');
    var onScroll = function () {
      var y = Math.max(window.scrollY || window.pageYOffset || 0, pw ? pw.scrollTop : 0);
      if (header) header.classList.toggle('is-scrolled', y > 24);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    if (pw) pw.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var hero = document.querySelector('.amb-hero--v3');
    if (hero && window.matchMedia('(hover: hover)').matches) {
      var floats = hero.querySelectorAll('[data-depth]');
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        var dx = (e.clientX - r.left) / r.width - 0.5;
        var dy = (e.clientY - r.top) / r.height - 0.5;
        floats.forEach(function (f) {
          var d = parseFloat(f.getAttribute('data-depth')) || 0;
          f.style.setProperty('--mx', (dx * d * 600).toFixed(1) + 'px');
          f.style.setProperty('--my', (dy * d * 600).toFixed(1) + 'px');
        });
      });
      hero.addEventListener('mouseleave', function () {
        floats.forEach(function (f) { f.style.setProperty('--mx', '0px'); f.style.setProperty('--my', '0px'); });
      });
    }

    /* Blog cards (snippets/amb-blog-row): the cover photo follows the pointer like the hero photos */
    if (window.matchMedia('(hover: hover)').matches) {
      document.querySelectorAll('.amb-entry').forEach(function (card) {
        var f = card.querySelector('.amb-entry__float');
        if (!f) return;
        var d = parseFloat(f.getAttribute('data-depth')) || 0;
        card.addEventListener('mousemove', function (e) {
          var r = card.getBoundingClientRect();
          var dx = (e.clientX - r.left) / r.width - 0.5;
          var dy = (e.clientY - r.top) / r.height - 0.5;
          f.style.setProperty('--mx', (dx * d * 600).toFixed(1) + 'px');
          f.style.setProperty('--my', (dy * d * 600).toFixed(1) + 'px');
        });
        card.addEventListener('mouseleave', function () {
          f.style.setProperty('--mx', '0px'); f.style.setProperty('--my', '0px');
        });
      });
    }

    /* Theme editor: reveal blocks the merchant is editing right away */
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('[data-amb-reveal]').forEach(function (el) { el.classList.add('is-in'); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
